import * as React from 'react';
import { Button } from 'antd';
import { getLangKey } from 'models/Language';
import { Organization } from 'models/Organization';
import * as translations from './strings';
import styles from './index.module.css';
import FilterPopover, { LayoutStyle } from './FilterPopover';
import { UserTaskFilter } from '../types';
import { useHandleMultipleFilterChange } from './handleFilterChange';
import { filters } from './filters';

type Props = {
  onFilter: (filterParams: UserTaskFilter) => void;
  defaultFilter?: UserTaskFilter;
  organization: Organization;
  showClear: boolean;
};

const FilterPanel: React.FC<Props> = ({
  onFilter,
  defaultFilter,
  organization,
  showClear
}) => {
  const strings = translations[getLangKey()];
  const [filterParams, setFilterParams] = React.useState<UserTaskFilter>({
    ...defaultFilter
  });

  const triggerFilter = () => {
    const filters: UserTaskFilter = {
      ...filterParams,
      dueAtEnd: filterParams.dueAtEnd || filterParams.dueAtStart,
      createdAtEnd: filterParams.createdAtEnd || filterParams.createdAtStart,
      updatedAtEnd: filterParams.updatedAtEnd || filterParams.updatedAtStart
    };
    setFilterParams(filters);
    onFilter(filters);
  };

  const resetFilters = (filters: UserTaskFilter) => {
    setFilterParams(filters);
    onFilter(filters);
  };

  useHandleMultipleFilterChange({
    filterParams,
    triggerFilter,
    defaultFilter
  });

  return (
    <div className={styles.filterPanel}>
      <div className={styles.filtersContainer}>
        <span className={styles.boldFont}>{strings.FilterBy}</span>
        {filters({
          filterParams,
          setFilterParams,
          organization
        }).map(
          ({
            key,
            layoutStyle = LayoutStyle.Horizontal,
            isFilterApplied,
            withSearch,
            resetParams,
            content
          }) => (
            // @ts-expect-error
            <FilterPopover
              key={key}
              className={styles.filterPopover}
              buttonText={strings[key]}
              isFilterApplied={
                isFilterApplied !== undefined
                  ? isFilterApplied
                  : !!filterParams[key]
              }
              layoutStyle={layoutStyle}
              onSearch={withSearch ? triggerFilter : undefined}
              onReset={() => resetFilters({ ...filterParams, ...resetParams })}
            >
              {content}
            </FilterPopover>
          )
        )}
        {showClear && (
          <Button
            className={styles.clearButton}
            onClick={() => resetFilters({})}
          >
            {strings.clear}
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterPanel;
